// extracted by mini-css-extract-plugin
export default {"cls1":"VeloForm-ErrorMessage_cls1__KEvt1","cls2":"VeloForm-ErrorMessage_cls2__u6tq8 VeloForm-ErrorMessage_cls1__KEvt1"};